export default {
    data() {
        return {
            documentPath: window.DOCUMENT_PATH//
        }
    }
}